export function downloadCSV(objects: object[]) {
  if (!objects || objects.length == 0) {
    return;
  }

  let gotHeader = false;
  let csv: string = objects.reduce((content: string, item: object) => {
    const [header, row] = convertObjToCSV(item);
    let entry = `${row}`;

    if (!gotHeader) {
      entry = `${header}\n${entry}`;
      gotHeader = true;
    }

    return content && content !== '' ? `${content}\n${entry}` : entry;
  }, '');

  const blob = new Blob([csv], {type: 'text/csv'});
  const url = (window.URL || window.webkitURL).createObjectURL(blob);

  window.location.href = url;
}

export function convertObjToCSV(obj: object): [string, string] {
  let mapped = new Array();
  // Flatten the object
  getPropertiesAsMap(obj, null, mapped);

  let keys = Object.keys(mapped);
  // Extract the first header and value
  let header = keys.shift();
  let values = mapped[header];

  // Append additional property name/value
  // to respective strings. The header string
  // will be the first row of the CSV. The
  // values string will be the second.
  keys.forEach(key => {
    header = String(header).concat(',', key);
    values = String(values).concat(',', mapped[key]);
  });

  return [header, values];
}

function getPropertiesAsMap(obj: object, name: string, mapped: Array<any>) {
  // Iterate through the properties of the object and
  // map them to key value pairs in a hash
  Object.keys(obj).forEach(key => {
    // Prepend any existing name to the current object key
    // as an existing name indicates that there is a parent
    // object and the name represents the name of a property
    // of the parent. This is how we flatten properties
    let new_name = name ? `${name}.${key}` : key;

    // If the value of the property is an object
    // then flatten it's properties as well
    if(obj[key] && typeof(obj[key]) == 'object') {
      getPropertiesAsMap(obj[key], new_name, mapped);
    }
    else {
      mapped[new_name] = obj[key] ? obj[key] : '';
    }
  });
}